import React from 'react';
import PropTypes from 'prop-types';
import ColorPicker from 'react-best-gradient-color-picker';
import styles from './GradientColorPicker.scss';

const GradientColorPicker = ({
  onChange,
  color,
  hideGradientControls,
}) => {
  const colorValue = color.length > 1 ? color : 'rgba(255, 255, 255, 1)';

  return (
         <div className={styles.colorPickerContainer}>
            <ColorPicker
              value={colorValue}
              onChange={(selectedColor) => {
                onChange({ value: selectedColor });
              }}
              hideControls={hideGradientControls}
              hidePresets
              hideEyeDrop
              hideAdvancedSliders
              hideColorGuide
              hideInputType
            />
            <div className={styles.gradientColorPickerPreview} id="gradient-color-picker-preview" style={{ background: colorValue }} />
         </div>
  );
};

GradientColorPicker.defaultProps = {
  color: 'rgba(255, 255, 255, 1)',
};

GradientColorPicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string,
};

export default GradientColorPicker;
